<template>
	<input type="hidden" name="action">
	<button class="
							bg-brand-blue-400
							hover:bg-brand-blue-200
							text-white
							font-bold
							py-2
							px-4
							mr-2
							rounded
							uppercase
						" type="submit">
		Save Review
	</button>
</template>
